<template>
  <div class="page page-watch">
    <div class="split-container">
      <!-- TODO: убрать/ уменьшить лаги-->
      <split-pane @resize="e => { resize = e }" :min-percent='20' :default-percent='61' split="vertical">
        <template slot="paneL">
          <OLMap class="map" :resize="resize" />
        </template>
        <template slot="paneR">
          <MapBar class="map-bar" />
        </template>
      </split-pane>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SplitPane from 'vue-splitpane'

export default {
  name: 'Watch',
  components: { SplitPane },
  data () {
    return {
      resize: '',
      windowWidth: 0
    }
  },
  mounted () {
    if (!this._timeout) {
      this.startWatch()
    }
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  computed: {
    ...mapState('taxi/mapcars', {
      cars: state => state.items.filter(car => car.imei),
      isLoading: state => state.isLoading
    })
  },
  methods: {
    ...mapActions('taxi/mapcars', [
      'loadItems',
      'abortLoading',
      'selectCar'
    ]),
    startWatch () {
      if (!this.isLoading) {
        this.loadItems()
      }
      this._timeout = setTimeout(() => { this.startWatch() }, 4000)
    }
  },

  beforeDestroy () {
    clearTimeout(this._timeout)
    this._timeout = null
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/scss/globals.scss";
  .map-bar {
    background-color: white;
    height: 100%;
    padding: 0 0.5rem 1rem 1.25rem;
    overflow-y: scroll;
  }
  @media all and (max-width: 1199px) {
    .map-bar {
      /* position: relative; */
      padding: 0 0.5rem 1rem 0;
    }
    .split-container {
      ::v-deep .splitter-paneL {
        position: relative !important;
        padding-right: 0;
        height: calc(39vh - #{$bwlayuotHeader}) !important;
        width: calc(100vw - #{$bwlayuotLeftSmallMenu}) !important;
      }
      ::v-deep .splitter-paneR {
        position: relative !important;
        width: calc(100vw - #{$bwlayuotLeftSmallMenu}) !important;
        height: 61vh !important;
      }
      ::v-deep .splitter-pane-resizer {
        display: none;
      }
    }
  }
  @media all and (max-width: 768px) {
    .split-container {
      ::v-deep .splitter-paneL {
        width: calc(100vw) !important;
      }
      ::v-deep .splitter-paneR {
        width: calc(100vw) !important;
      }
    }
  }

  .hint-resizable {
    border: 1px solid #707070;
    border-radius: 25px;
    width: 25px;
    height: 25px;
  }
  .hint-resizable-icon {
    size: 20px;
  }
  .page-watch {
    height: 100%;
    padding: 0;
  }
  .split-container {
    position: relative;
    height: 100%;
  }
</style>
